import { createTheme } from '@mui/material/styles';

// Single source of truth for brand colors. #FFCA18 is the only brand hue;
// everything else is a shade/tint of it or neutral ink.
export const BRAND = {
  yellow: '#FFCA18',
  yellowDark: '#E6AF00', // hover / pressed
  yellowDeep: '#B78900', // text on light tint, small accents
  tint: 'rgba(255, 202, 24, 0.10)', // soft section backgrounds
  tintStrong: 'rgba(255, 202, 24, 0.25)',
  ink: '#1A1A1A',
  inkSecondary: '#5C5647', // warm gray derived from ink+yellow
  dark: '#14110A', // warm near-black for dark sections
  paper: '#FFFFFF',
};

export const RADIUS = {
  button: '10px',
  card: '14px',
};

export const SHADOW = {
  card: '0 6px 24px rgba(26, 26, 26, 0.07)',
  cardHover: '0 10px 32px rgba(26, 26, 26, 0.12)',
  cta: '0 6px 18px rgba(255, 202, 24, 0.35)',
};

const landingTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: BRAND.yellow,
      dark: BRAND.yellowDark,
      contrastText: BRAND.ink,
    },
    text: {
      primary: BRAND.ink,
      secondary: BRAND.inkSecondary,
    },
    background: {
      default: BRAND.paper,
      paper: BRAND.paper,
    },
  },
  typography: {
    fontFamily: '"Inter", "Helvetica Neue", "Arial", sans-serif',
    h1: { fontWeight: 800, letterSpacing: '-0.03em' },
    h2: { fontWeight: 800, letterSpacing: '-0.02em' },
    h3: { fontWeight: 700, letterSpacing: '-0.02em' },
    h4: { fontWeight: 800, letterSpacing: '-0.02em' },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { fontWeight: 700, textTransform: 'none' },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: RADIUS.button,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: RADIUS.card,
        },
      },
    },
  },
});

export default landingTheme;
